<script lang="ts" setup>
export interface PagebuilderStickerProps {
    data: {
        sticker_title: string
        sticker_description: string
        sticker_published_from: string
        sticker_published_to: string
        anchor_id: string
        anchor_title: string
        anchor_in_menu: string
    }
}
const props = defineProps<PagebuilderStickerProps>()

const isVisible = computed((): boolean => {
    if (!props.data.sticker_published_from || !props.data.sticker_published_to) {
        return true
    }

    const now = new Date()
    const publishedFrom = new Date(props.data.sticker_published_from)
    const publishedTo = new Date(new Date(props.data.sticker_published_to).getTime() - 60 * 60 * 1000)

    return now >= publishedFrom && now <= publishedTo
})

</script>

<template>
  <Teleport
    v-if="isVisible"
    to=".headline-sticker-wrapper"
  >
    <div class="d-inline-block pagebuilder-sticker">
      <aside 
        class="d-flex gap-3 bg-secondary rounded-5 shadow-sm text-white p-6 py-8 pagebuilder-sticker__decor"
        role="complementary"
        :aria-label="props.data.sticker_title"
      >
        <div 
          aria-hidden="true"
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style="display: block;  image-rendering: -webkit-optimize-contrast;"
          >
            <title>Časovo obmedzená informácia</title>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.351 0.02c.023-.007.048-.013.073-.018.165-.015.33.04.453.153.12.11.188.268.181.432v3.685c2.387-2.27 5.668-3.685 9.275-3.685 7.382 0 13.334 5.82 13.334 13.04 0 7.22-5.952 13.04-13.334 13.04-7.382 0-13.333-5.82-13.333-13.04 0-2.135.541-4.21 1.449-5.988l1.033.514c-.831 1.623-1.322 3.528-1.322 5.474 0 6.613 5.412 11.906 12.174 11.906s12.174-5.293 12.174-11.906c0-6.613-5.412-11.906-12.174-11.906-3.322 0-6.315 1.307-8.496 3.402h3.858c.209-.002.404.104.51.281.104.177.104.394 0 .571-.106.177-.301.284-.51.282H2.899V0.587c-.007-.27.183-.507.452-.567zm9.402 12.632V4.556h1.16v8.096c.346.197.58.556.58.975 0 .627-.519 1.134-1.16 1.134-.1 0-.197-.011-.29-.035l-3.931 3.844-.833-.815 3.931-3.845c-.025-.09-.036-.186-.036-.283 0-.419.233-.778.58-.975z"
              fill="currentColor"
              stroke="currentColor"
              stroke-width="1"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="d-flex flex-column">
          <p class="delta fw-bold text-white lh-1 mb-0">
            {{ props.data.sticker_title }}
          </p>
          <p 
            v-if="props.data.sticker_description" 
            class="fs-smaller fw-normal mb-0"
          >
            {{ props.data.sticker_description }}
          </p>
        </div>
      </aside>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped>
@import './PageBuilderSticker.scss';
</style>
